<template>
  <div id="home">
    <div class="banner">
      <div class="wrapper">
          <swiper :options="swiperOption" class="swiper-container" >
            <!-- slides -->
            <swiper-slide class="swiper-item" v-for="(item,index) in bannerList" :key="index">
                <img :src="item.img" alt="" class="bannerImg" ref="imgHeight"  >
                <div class="imgBox">
                  <div class="text">
                    <div class="title">{{$t(item.text)}}<img class="imglog" :src="item.imglog" alt=""></div>
                    <div class="detail">
                      {{$t(item.detail)}}
                    </div>
                  </div>
                  <img class="smallimg" :src="item.smallimg" alt="">
                </div>
            </swiper-slide>
            <!-- Optional controls ,显示小点-->
            <div class="swiper-pagination"  slot="pagination"></div>
          </swiper>
        </div>
    </div>
    <div class="content1" >
      <el-row class="con" :gutter="10"  style="margin: 0 auto;">
        <el-col :xs="24" :sm="24" :lg="6" v-for="item in con1" :key="(item.tit,item.con)">
          <div class="box wow fadeInUp" :data-wow-duration="item.duration" data-wow-delay="0.5s">
            <div class="img"><img :src="item.src" alt=""></div>
            <div>
              <div class="tit">{{$t(item.tit)}}</div>
              <div class="detail">{{$t(item.con)}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content2">
      <div class="box">
        <div class="tit">{{$t('home.con2.title1')}}</div>
        <div class="wrapper">
          <swiper :options="swiperOption" class="swiper-container" >
            <!-- slides -->
            <swiper-slide class="swiper-item" v-for="(item,index) in contentList1" :key="(item.title,item.titleSub,item.con)">
                <img :src="item.img" alt="" class="bannerImg" >
              <div class="imgBox" v-if="index==index">
                <div class="conBoxTitle">{{$t(item.title)}}</div>
                <div class="text">
                  <div class="title">{{$t(item.titleSub)}}</div>
                  <div class="detail">
                    {{$t(item.con)}}
                  </div>
                </div>
              </div>
            </swiper-slide>
            <!-- Optional controls ,显示小点-->
            <div class="swiper-pagination"  slot="pagination"></div>
          </swiper>
        </div>
        <div class="list conBoxBtn">
          <router-link :to="{path:'/mSoftware'}">
            <div class="moreBtn"> {{$t('home.moreBtn')}} <img src="/static/images/common/bt_more.png" alt=""></div>
          </router-link>
        </div>
      </div>
      <div class="box">
        <div class="tit">{{$t('home.con2.title2')}}</div>
        <div class="wrapper">
          <swiper :options="swiperOption" class="swiper-container" >
            <!-- slides -->
            <swiper-slide class="swiper-item" v-for="(item,index) in contentList2" :key="(item.title,item.titleSub,item.con)">
                <img :src="item.img" alt="" class="bannerImg" >
              <div class="imgBox" v-if="index==index">
                <div class="conBoxTitle">{{$t(item.title)}}</div>
                <div class="text">
                  <div class="title">{{$t(item.titleSub)}}</div>
                  <div class="detail">
                    {{$t(item.con)}}
                  </div>
                </div>
              </div>
            </swiper-slide>
            <!-- Optional controls ,显示小点-->
            <div class="swiper-pagination"  slot="pagination"></div>
          </swiper>
        </div>
        <div class="list conBoxBtn">
          <router-link :to="{path:'/mSoftware'}">
            <div class="moreBtn"> {{$t('home.moreBtn')}} <img src="/static/images/common/bt_more.png" alt=""></div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="content3">
      <!-- <div class="con">
        <router-link :to="{path:'/mBlogDetail'}">
          <div class="box wow fadeInUp" :data-wow-duration="item.duration" data-wow-delay="0.5s" v-for="(item,index) in con3List" :key="(item.tit,item.text,item.titSub,index)">
              <div class="conImg"><img class="con3Img" :src="item.src" alt=""></div>
              <div class="conText">
                  <div class="tit">{{$t(item.tit)}}</div>
                  <div class="titSub">{{$t(item.text)}}</div>
              </div>
          </div>
        </router-link>
        <div class="conBoxBtn">
          <router-link :to="{path:'/mBlog'}">
            <div class="moreBtn"> {{$t('home.moreBtn')}} <img src="/static/images/common/bt_more.png" alt=""></div>
          </router-link>
        </div>
      </div> -->
      <div class="con shop">
        <div class="title">{{$t("home.con3.tit")}}</div>
        <div><img src="/static/images/home/m_con4_6.svg" alt=""></div>
        <div class="flexBox">
          <div class="boxs">
            <div class="tit">{{$t("home.con3.titSub")}}</div>
            <div class="detail">{{$t("home.con3.detail")}}</div>
          </div>
          <div class="boxs"><img src="/static/images/home/con4_7.png" alt=""></div>
        </div>
      </div>
    </div>
    <div class="content4">
        <div class="con">
          <div class="tit">
              {{$t("home.con4.tit1")}}
          </div>
          <div class="titSub">{{$t("home.con4.tit2")}}</div>
          <div class="conText">{{$t("home.con4.titSub")}}</div>
          <div class="conBoxBtn">
            <router-link :to="{path:'/mAbout'}">
              <div class="moreBtn"> {{$t('home.moreBtn')}} <img src="/static/images/common/bt_more.png" alt=""></div>
            </router-link>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { WOW } from 'wowjs';
import 'swiper/dist/css/swiper.css'////这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption:{
        // 参数选项,显示小点
        pagination:'.swiper-pagination',
        //循环
        loop:true,
        //每张播放时长3秒，自动播放
        autoplay:3000,
        //滑动速度
        speed:500,
        // delay:1000
      },
      imgHeight: '150px',
      imgHeights: '150px',
      bannerList:[
        {
          img:'/static/images/home/m_con1_1.png',
          smallimg:'/static/images/home/m_con1_1_2.png',
          imglog:'/static/images/home/con1_1_2.png',
          text:'home.banner.banner1.bannerText',
          detail:'home.banner.banner1.bannerDetail'
        },
        {
          img:'/static/images/home/m_con1_2.png',
          smallimg:'/static/images/home/m_con1_2_1.png',
          text:'home.banner.banner2.bannerText',
          detail:'home.banner.banner2.bannerDetail',
          imglog:''
        }
      ],
      activeName: 'one',
      boxShow:false,
      selectId:0,
      show:false,
      textShow:false,
      menuShow:false,
      con1:[
        {
          tit:'home.con1.tit1',
          con:'home.con1.con1',
          src:'/static/images/home/m_con2_1.png',
          duration:'1s'
        },
        {
          tit:'home.con1.tit2',
          con:'home.con1.con2',
          src:'/static/images/home/m_con2_2.png',
          duration:'1.2s'
        },
        {
          tit:'home.con1.tit3',
          con:'home.con1.con3',
          src:'/static/images/home/m_con2_3.png',
          duration:'1.4s'
        },
        {
          tit:'home.con1.tit4',
          con:'home.con1.con4',
          src:'/static/images/home/m_con2_4.png',
          duration:'1.6s'
        },
      ],
      contentList1:[
        {
          img:'/static/images/home/pos/m_con3_1.png',
          title:'home.con2.table1.title1',
          titleSub:'home.con2.table1.titleSub1',
          con:'home.con2.table1.con1',
        },
       {
          img:'/static/images/home/pos/m_con3_2.png',
          title:'home.con2.table1.title2',
          titleSub:'home.con2.table1.titleSub2',
          con:'home.con2.table1.con2',
        },
       {
          img:'/static/images/home/pos/m_con3_3.png',
          title:'home.con2.table1.title3',
          titleSub:'home.con2.table1.titleSub3',
          con:'home.con2.table1.con3',
        },
       {
          img:'/static/images/home/pos/m_con3_4.png',
          title:'home.con2.table1.title4',
          titleSub:'home.con2.table1.titleSub4',
          con:'home.con2.table1.con4',
        },
      ],
      contentList2:[
        {
          img:'/static/images/home/web/m_con3_1.png',
          title:'home.con2.table2.title1',
          titleSub:'home.con2.table2.titleSub1',
          con:'home.con2.table2.con1',
        },
       {
          img:'/static/images/home/web/m_con3_2.png',
          title:'home.con2.table2.title2',
          titleSub:'home.con2.table2.titleSub2',
          con:'home.con2.table2.con2',
        },
       {
          img:'/static/images/home/web/m_con3_3.png',
          title:'home.con2.table2.title3',
          titleSub:'home.con2.table2.titleSub3',
          con:'home.con2.table2.con3',
        },
       {
          img:'/static/images/home/web/m_con3_4.png',
          title:'home.con2.table2.title4',
          titleSub:'home.con2.table2.titleSub4',
          con:'home.con2.table2.con4',
        },
      ],
      con3List:[
        {
          tit:'home.con1.tit1',
          text:'home.con1.tit1',
          src:'/static/images/home/con4_2.png',
          duration:'1.4s'
        },
        {
          tit:'home.con1.tit1',
          text:'home.con1.tit1',
          src:'/static/images/home/con4_3.png',
          duration:'1.6s'
        },
        {
          tit:'home.con1.tit1',
          text:'home.con1.tit1',
          src:'/static/images/home/con4_4.png',
          duration:'1.8s'
        },
        {
          tit:'home.con1.tit1',
          text:'home.con1.tit1',
          src:'/static/images/home/con4_5.png',
          duration:'2s'
        },
        // {
        //   tit:'home.con1.tit1',
        //   text:'home.con1.tit1',
        //   src:'/static/images/home/con4_5.png',
        //   duration:'1.8s'
        // }
      ],


    };
  },
  //定义这个sweiper对象
  computed: {},
  mounted() {
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: false
    })
    wow.init();
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener('resize', () => {
      // this.imgHeight = this.$refs.imgHeight[0].height
      // this.imgLoad()
    })
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {
    //  imgLoad() {
    //   this.$nextTick(() => {
    //     this.imgHeight = this.$refs.imgHeight[0].height
    //     this.imgHeights = this.$refs.imgHeight[0].height+65
    //     console.log(this.$refs.imgHeight[0].height)
    //   })
    // },
     handleClick(tab, event) {
        // console.log(tab, event);
    },
    conBoxShow(id){
      // console.log('id',id)
      this.selectId =id
      this.show =true
    },
    conBoxHidden(id){
      this.selectId =false
      // this.show =0
    },
    TextShow(id){
      this.textShow =id
    },
    TextHidden(id){
      this.textShow =false
    },
    menuShows(){
      this.menuShow = true
    },
    menuHiddens(){
      this.menuShow = false
    },
    tj_btn() {
      var that = this;
      if (this.name == "") {
        layer.msg(that.name_msg);
        return false;
      }
      if (this.phone == "") {
        layer.msg(that.phone_msg);
        return false;
      }
      if (this.text_con == "") {
        layer.msg(that.text_con_msg);
        return false;
      }

      //                that.$http.pos('/h5/user/login', this.$qs.stringify(
      //                    {
      //                        mobile_phone:that.inputValue,
      //                        code:that.verifyCode
      //                    }
      //                ))
      //                    .then(function (response) {
      //                        console.log(response);
      //                        if(response.data.err==1){
      //
      //
      //                        }else{
      //
      //                        }
      //
      //                    })
      //                    .catch(function (response) {
      //
      //                    })
    },
    changeLangEvent() {
      var that = this;
      if (this.$getCookie("langs") == "en") {
        this.$setCookie("langs", "zh");
        this.lang = "zh";
        this.$i18n.locale = this.lang; //关键语句
        that.$router.push("/Home");
        window.location.reload();
      } else {
        this.$setCookie("langs", "en");
        this.lang = "en";
        this.$i18n.locale = this.lang; //关键语句
        that.$router.push("/Home");
        window.location.reload();
      }
    }
  }
};
</script>
<style lang="less" type="text/less">
#home{
 .banner{
    margin-top: 70px;
  }

  .wrapper{
      .swiper-wrapper{
        .swiper-item{
          .bannerImg{
            width: 100%;
          }
        }
      }

  }
  .swiper-container{
    padding: 0px 0 20px 0;
    .swiper-pagination{
      bottom: 0;
    }
  }
  .swiper-pagination-bullet{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ccc;
    opacity: 1;
  }
  .swiper-pagination-bullet-active{
    width: 20px;
    height: 10px;
    border-radius: 8px;
  }
  .content2{
    .el-carousel__button{
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: #ccc;
    }
    .el-carousel__indicator.is-active .el-carousel__button{
      width: 30px;
      height: 15px;
      border-radius: 8px;
    }
    .el-tabs{
      position: relative;
      height: 100%;
    }
    .el-tabs__header{
      padding-top: 5%;
    }
    .el-tabs__nav{
      float: none;
      text-align: center;
      padding:0 0 20px 0;
    }
    .el-tabs__active-bar{
      display: none;
    }
    .el-tabs__item{
      margin-right: 30px;
      font-size: 26px;
      // width: 50%;
      font-weight: bold;
      display: inline-block;
    }
     .el-tabs__item:nth-child(2){
       text-align: right;
       margin-right: 10%;
       padding: 0;
     }
     .el-tabs__item:nth-child(3){
       text-align: left;
       margin-left: 10%;
       padding: 0;
     }
    .el-tabs__item:hover{
      color: #FF9600;
    }
    .el-tabs__item.is-active{
      color: #FF9600;
      position: relative;
    }
    .el-tabs__item:nth-child(2).is-active::after{
      background: #FF9600;
      content:'';
      display: inline-block;
      height: 4px;
      position: absolute;
      z-index: 12;
      bottom: -20px;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
    }
    .el-tabs__item:nth-child(3).is-active::after{
      background: #FF9600;
      content:'';
      display: inline-block;
      height: 4px;
      position: absolute;
      z-index: 12;
      bottom: -20px;
      left: 0;
      left: 0;
      margin: auto;
      width: 100%;
    }
    .el-tabs__nav-wrap::after{
      height: 4px;
    }
    .el-tabs__content{
      position:absolute;
      bottom:0;
      height: 100%;
    }
    .el-tab-pane{
      height: 100%;
    }
  }
}
</style>
<style scoped lang="less" type="text/less">
#home{
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease-in;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .banner{
    margin-top: 50px;
    position: relative;
    background: #f8f8f8;
    padding-bottom: 15px;
    // position: fixed;
    // z-index: -1;
    // top: 0;
    // width: 100%;
    .bannerImg{
      width: 100%;
    }
    .imgBox{
      width: 80%;
      margin:auto;
      position: absolute;
      left: 0;
      right: 0;
      top: 60%;
      text-align: center;
      .smallimg{
         width: 70%;
      }
      .imglog{
        margin-left: 1rem;
        width: 35px;
        position: absolute;
        top: -.2rem;
      }
      .text{
          .title{
            font-size: 2rem;
            color: #333;
            font-weight: bold;
          }
          .detail{
            font-size: 1.4rem;
            color: #666;
            padding: 2rem 0 1.4rem 0;
          }
      }
    }
  }
  .content1{
    width: 100%;
    padding: 3rem 0px;
    text-align: left;
    background: #fff;
    // display: flex;
    // justify-content: space-between;
    // align-items: flex-start;
    .con{
      width: 90%;
      margin: 0 auto;
      .box{
        padding: 10px 15px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img{
          margin-right: 15px;
          width: 43px;
        }
        .tit{
          color: #333;
          font-size: 1.6rem;
          font-weight: bold;
        }
        .detail{
          color: #999;
          font-size: 1.2rem;
        }
      }

    }
  }
  .content2{
    background: #F8F8F8;
    padding: 3rem 0;
    .tit{
      text-align: center;
      font-size: 3rem;
      font-weight: bold;
      padding-bottom: 10px;
    }
    .box{
      width: 80%;
      margin: 0 auto;
      padding: 15px 0;
      .bannerImg{
        width: 100%;
      }
      .imgBox{
        padding: 15px 0;
        color: #333;
        .conBoxTitle{
          font-size: 2rem;
          font-weight: bold;
        }
        .text{
          .title{
            font-size: 1.6rem;
            color: #999;
          }
          .detail{
            font-size: 1.2rem;
          }
        }
      }
    }
    .conBoxBtn{
      margin: 2rem 0 5rem 0;
      text-align: center;
      .moreBtn{
        background: #27C2B4;
        box-shadow:0px 3px 6px rgba(11,128,117,0.26);
        border-radius:22px;
        display: inline-block;
        padding: 5px 20px;
        color: #fff;
        margin: 0 auto;
        cursor: pointer;
        img{
          position: relative;
          top: -2px;
        }
      }
    }

  }
  .content3{
    width: 80%;
    margin: 0 auto;
    padding: 4rem 0;
    background: #fff;
    .con{
      margin: 0 auto;
      .box{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 20px;
        .conImg{
          width: 30%;
          img{
          width: 100%;
          }
          margin-right: 20px;
        }
        .conText{
          width: 70%;
          color: #333;
          .tit{
            font-size: 1.8rem;
            font-weight: bold;
          }
          .titSub{
            font-size: 1.4rem;
            color: #666;
          }
        }
      }

      .conBoxBtn{
        margin: 40px 0 0 0;
        text-align: center;
        .moreBtn{
          background: #27C2B4;
          box-shadow:0px 3px 6px rgba(11,128,117,0.26);
          border-radius:22px;
          display: inline-block;
          padding: 5px 20px;
          color: #fff;
          margin: 0 auto;
          cursor: pointer;
          img{
            position: relative;
            top: -2px;
          }
        }
      }
    }
    .shop{
      img{
        width: 100%;
      }
      .title{
        font-size: 2.4rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 1rem;
      }
      .flexBox{
        margin-top: 2rem;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        .boxs{
          .tit{
            font-size: 2.4rem;
            font-weight: bold;
            color: #333;
            margin-bottom: 1rem;
          }
          .detail{
            font-size: 1.6rem;
            color: #666;
            margin-bottom: 1rem;
          }
        }
      }
    }
  }
  .content4{
    background: #f8f8f8;
    padding: 4rem 0;
    .con{
      margin: auto;
      width: 80%;
      .tit{
        font-size: 2.6rem;
        color: #333;
        font-weight: bold;
      }
      .titSub{
        font-size: 1.6rem;
        color: #333;
        padding: 10px 0;
        font-weight: bold;
      }
      .conText{
        font-size: 1.4rem;
        color: #666;
      }

      .conBoxBtn{
        margin-top: 20px;
        text-align: center;
        .moreBtn{
          background: #27C2B4;
          box-shadow:0px 3px 6px rgba(11,128,117,0.26);
          border-radius:22px;
          display: inline-block;
          padding: 5px 20px;
          color: #fff;
          cursor: pointer;
          img{
            position: relative;
            top: -2px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/home.vue